/** English is the source language: keys are the English UI strings. */
export const en: Record<string, string> = {
  "n relays": "{n} relays",
  "n notes": "{n} notes",
  "n reviews": "{n} reviews",
  "n people": "{n} people",
  "relays connected": "{connected} of {total} relays connected",
}
